import { InjectionToken } from '@angular/core';
import { DashboardDataService } from './dashboard-data.service';

export const DASHBOARD_DATA_SERVICE = new InjectionToken<DashboardDataService>('DASHBOARD_DATA_SERVICE');
